import { Link } from "react-router-dom";
import * as Icons from "lucide-react";

export const CATEGORY_ICONS = ["GraduationCap", "School", "Building2", "Users", "BookOpen", "HandCoins", "Brain", "Trophy", "Star", "Lightbulb", "Target", "Laptop", "Globe", "Award"];

export default function CategoryTiles({ categories }) {
  if (!categories?.length) return null;
  return (
    <section data-testid="category-tiles" className="max-w-7xl mx-auto px-4 sm:px-8 pb-10">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-display text-lg md:text-2xl font-extrabold border-l-4 pl-3" style={{ borderColor: "#A3E635" }}>Browse by Category</h2>
        <Link to="/institutes" data-testid="categories-view-all" className="text-xs md:text-sm font-bold text-lime-700">View All →</Link>
      </div>
      <div className="flex md:grid md:grid-cols-6 gap-3 overflow-x-auto snap-x pb-2 -mx-4 px-4 md:mx-0 md:px-0" style={{ scrollbarWidth: "none" }}>
        {categories.map((c) => {
          const Icon = Icons[c.icon] || Icons.GraduationCap;
          const img = c.image_mobile || c.image_desktop;
          return (
            <Link key={c.id} to={c.link || "/institutes"} data-testid={`category-tile-${c.id}`}
              className="snap-start shrink-0 w-[27%] sm:w-28 md:w-auto flex flex-col items-center gap-2 text-center">
              <span className="w-full aspect-square rounded-2xl border-2 border-[#171B33] flex items-center justify-center overflow-hidden transition-transform duration-150 hover:-translate-y-0.5"
                style={{ background: c.color || "#F2FBE3", boxShadow: "3px 3px 0 #171B33" }}>
                {img ? <picture className="w-full h-full">
                  {c.image_desktop && <source media="(min-width: 768px)" srcSet={c.image_desktop} />}
                  <img src={img} alt={c.label} className="w-full h-full object-cover" />
                </picture> : <Icon className="w-8 h-8 md:w-10 md:h-10" />}
              </span>
              <span className="text-[11px] md:text-sm font-bold leading-tight">{c.label}</span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
